import {
    GET_PARAMETERS_OF_SELECTED_ELEMENTS,
    SAVE_SELECTION_OF_VIEWER
} from "../constans";

import {
  getCustomParameters,
  getCommonParametersValuesByIds,
  GetCustomParameterValue,
  getSelection,
} from "../../utils/builder/IScheduleLogic";

import { logError } from "../../utils/builder/IAmecLog";

export const getParametersOfSelectedElements = () => async (dispatch) => {
  try {
    const selectedElementIds = await getSelection()

    const customProperties = await getCustomParameters();
    const commonParameters = await getCommonParametersValuesByIds(selectedElementIds)
  
    if (!commonParameters)
      return

    const parametersOfSelection = {}

    for (const elemId of Object.keys(commonParameters)) {
      // Clone the parameter definitions so each element gets independent objects
      const clonedCustomParams = customProperties.map(p => ({ ...p }))

      for (const customParam of clonedCustomParams) {
          const paramName = customParam.name
          customParam.selectedValue = await GetCustomParameterValue(paramName, elemId)
      }

      parametersOfSelection[elemId] = {
          customProperties: clonedCustomParams,
          common: commonParameters[elemId]
      }
    }

    dispatch({
      type: GET_PARAMETERS_OF_SELECTED_ELEMENTS,
      payload: { parametersOfSelection }
    });
    
  } catch (err) {
    logError("FrontEnd.src.store.actions.viewer.getParametersOfSelectedElements", err.toString());
  }
};

export const saveSelectionOfViewer = (payload) => async (dispatch) => {

  try {
    dispatch({
      type: SAVE_SELECTION_OF_VIEWER,
      payload: payload
    })
  } catch (err) {
    logError("FrontEnd.src.store.actions.viewer.saveSelectionOfViewer", err.toString());
  } 
;
};


